type Session = {
  sessionId: string;
  name: string;
};

type SessionTimelineSegment = {
  activity: string;
  group: string;
  leader: string;
  name: string;
  isFlex: boolean;
  enabled: boolean;
};

type SegmentReorderedEventPayload = {
  session: Session;
  segment: SessionTimelineSegment;
  fromIndex: number;
  toIndex: number;
};

export function formatSegmentReorderedEvent(
  session: Session,
  segment: SessionTimelineSegment,
  fromIndex: number,
  toIndex: number
): SegmentReorderedEventPayload {
  const { sessionId, name: sessionName } = session;
  const { activity, group, leader, name: segmentName, isFlex, enabled } = segment;
  return {
    session: { sessionId, name: sessionName },
    segment: { activity, group, leader, name: segmentName, isFlex, enabled },
    fromIndex,
    toIndex,
  };
}
